// Noolara theme interactions
document.addEventListener('DOMContentLoaded', function () {
  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Color swatch + gallery (product page)
  var colorways = window.noolaraColorways || null;
  if (colorways) {
    var mainImg = document.getElementById('mainImg');
    var thumbs = document.getElementById('thumbnails');
    function loadColorway(name) {
      var images = colorways[name];
      if (!images || !images.length) return;
      if (mainImg) mainImg.src = images[0];
      if (!thumbs) return;
      thumbs.innerHTML = '';
      images.forEach(function (src, i) {
        var d = document.createElement('div');
        d.className = 'thumb' + (i === 0 ? ' active' : '');
        d.innerHTML = '<img src="' + src + '" alt="">';
        d.addEventListener('click', function () {
          document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
          d.classList.add('active');
          if (mainImg) mainImg.src = src;
        });
        thumbs.appendChild(d);
      });
    }
    document.querySelectorAll('.color-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        document.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        var name = sw.getAttribute('data-color');
        var label = document.getElementById('selectedColor');
        if (label) label.textContent = name;
        loadColorway(name);
      });
    });
  }
});

/* Product card color swatch hover → swap image */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-card').forEach(function (card) {
    var img = card.querySelector('.product-card-img');
    if (!img) return;
    var defaultSrc = img.getAttribute('data-default-src') || img.src;

    card.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        var src = sw.getAttribute('data-image');
        if (src) img.src = src;
        card.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
      });
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var src = sw.getAttribute('data-image');
        if (src) {
          img.src = src;
          img.setAttribute('data-default-src', src);
        }
        card.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
      });
    });

    card.addEventListener('mouseleave', function () {
      img.src = img.getAttribute('data-default-src') || defaultSrc;
    });
  });
});



/* Search overlay — half panel */
document.addEventListener('DOMContentLoaded', function () {
  var openBtn = document.getElementById('SearchOpen');
  var overlay = document.getElementById('SearchOverlay');
  var backdrop = document.getElementById('SearchBackdrop');
  var closeBtn = document.getElementById('SearchClose');
  var input = document.getElementById('SearchInput');
  if (!openBtn || !overlay) return;

  function openSearch(e) {
    if (e) e.preventDefault();
    overlay.hidden = false;
    overlay.removeAttribute('hidden');
    if (backdrop) { backdrop.hidden = false; backdrop.removeAttribute('hidden'); }
    document.body.classList.add('search-open');
    openBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (input) input.focus(); }, 40);
  }
  function closeSearch(e) {
    if (e) e.preventDefault();
    overlay.hidden = true;
    overlay.setAttribute('hidden', '');
    if (backdrop) { backdrop.hidden = true; backdrop.setAttribute('hidden', ''); }
    document.body.classList.remove('search-open');
    openBtn.setAttribute('aria-expanded', 'false');
  }

  openBtn.addEventListener('click', openSearch);
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeSearch();
  });
});
